import LoadHistoryDrawer from './load-history-drawer';

export default LoadHistoryDrawer;
